"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UIButtonWrapper = _interopRequireDefault(require("../layout/UIButtonWrapper"));

var ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};

var getLayoutType = function getLayoutType(className, layout) {
  if (layout) return layout;

  if (className) {
    _devLogger.default.warn({
      message: 'UIDialogFooter: Button layout is now improved out-of-the-box, but ' + "we didn't want to risk breaking any custom styling in your app. " + 'Remove this warning by setting layout="default" and seeing if you ' + 'still need your custom styles added via "className" or set it to ' + 'layout="legacy" to keep everything as it was.',
      key: 'UIDialogFooter: check classNames'
    });

    return 'legacy';
  }

  return 'default';
};

var _default = _react.default.createClass({
  displayName: "UIDialogFooter",
  propTypes: {
    align: _react.PropTypes.oneOf(['left', 'center', 'right', 'between']).isRequired,
    children: _react.PropTypes.node,
    layout: _UIButtonWrapper.default.propTypes.layout
  },
  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left'
    };
  },
  render: function render() {
    var _this$props = this.props,
        align = _this$props.align,
        children = _this$props.children,
        className = _this$props.className,
        layout = _this$props.layout,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["align", "children", "className", "layout"]);
    return _react.default.createElement("footer", (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)('private-modal__footer', 'uiDialogFooter', className)
    }), _react.default.createElement(_UIButtonWrapper.default, {
      justify: ALIGNMENT_OPTIONS[align],
      layout: getLayoutType(className, layout)
    }, children));
  }
});

exports.default = _default;
module.exports = exports.default;